export default "__VITE_ASSET__CNUPk43Y__"